<template>
  <b-card v-if="item" no-body class="sms-item">
    <!-- Header -->
    <div class="card-header w-100 d-flex justify-content-between">
      <span>
        <b-avatar variant="light-primary" :text="getInitials(item.publisher)" size="24" />
        <span class="font-weight-bolder text-capitalize">
          {{ item.publisher }}
        </span>
      </span>
      <div class="bl-1 d-flex justify-content-between">
        <span class="pl-50">
          {{
            item.published.toDate().toLocaleDateString('fi', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            })
          }}
        </span>
        <div>
          <b-badge
            :variant="getVaritantSms"
            class="badge-glow font-weight-normal card-status text-capitalize ml-50"
          >
            <feather-icon icon="ClockIcon" size="16" />
            {{ item.status }}
          </b-badge>
        </div>
      </div>
    </div>
    
    <!-- Body -->
    <div class="card-body">
      <div class="card-title text-capitalize">
        {{ item.title }}
      </div>

      <div class="card-sub-title">
        {{ item.message }}
      </div>
    </div>

    <!-- Footer -->
    <div class="card-footer pt-0">
      <div class="pt-1 bt-1 mb-50 d-flex justify-content-between">
        <span>{{
          `${item.contentLength} ${$t('sms.texts.characters')}`
        }}</span>
        <div>
          <b-badge
            v-for="(label, labelIndex) in getTargetLabels(item).slice(0, 4)"
            :key="`label-${labelIndex}`"
            pill
            :class="
              `badge-glow font-weight-normal card-status text-capitalize ${
                labelIndex ? 'ml-50' : ''
              }`
            "
            :variant="COLOR_VARIANTS.LIGHT_PRIMARY"
            :style="{ color: `${communicationTargetLabelsColor(labelIndex)} !important` }"
          >
            {{ label }}
          </b-badge>
        </div>
      </div>
      <div class="mb-50">
        {{
          `${item.segmentLength} ${$t('sms.texts.segments')}`
        }}
      </div>
      <div class="d-flex justify-content-between">
        <b-badge
          pill
          class="badge-glow font-weight-normal card-status text-capitalize"
          :variant="COLOR_VARIANTS.LIGHT_SECONDARY"
        >
          {{ `${item.price} €` }}
        </b-badge>
        <b-link class="font-weight-bolder" @click="$emit('show-info')">
          {{ $t('questionnaire.showDetails') }}
        </b-link>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BAvatar, BCard, BBadge, BLink } from 'bootstrap-vue'
import { getInitials, getTargetLabels } from '@hw-core/utils'
import { COLOR_VARIANTS } from '@/shared/constants/colors'
import { communicationTargetLabelsColor } from '@/shared/services/communicationService'

const STATUSES = {
  DRAFT: 'draft',
  SENDING: 'sending',
  SENT: 'sent',
  FAILED: 'failed',
}

export default {
  components: {
    BAvatar,
    BCard,
    BBadge,
    BLink,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      COLOR_VARIANTS,
    }
  },
  computed: {
    itemExist() {
      return Object.keys(this.item).length > 0
    },
    isDraft() {
      return this.itemExist && this.item.status === STATUSES.DRAFT
    },
    getVaritantSms() {
      const { status } = this.item
      let variant = ''
      if (status === STATUSES.SENT) {
        variant = COLOR_VARIANTS.LIGHT_SUCCESS
      } else if (status === STATUSES.SENDING) {
        variant = COLOR_VARIANTS.LIGHT_INFO
      } else if (status === STATUSES.FAILED) {
        variant = COLOR_VARIANTS.LIGHT_DANGER
      } else if (status === STATUSES.DRAFT) {
        variant = COLOR_VARIANTS.LIGHT_SECONDARY
      }
      return variant
    },
  },
  methods: {
    getInitials,
    getTargetLabels,
    communicationTargetLabelsColor,
  },
}
</script>

<style lang="scss" scoped>
@import './styles/sms-item.scss';
</style>
